/**!
 * Created by Leonardo Cheslacki on 28/04/2022.
 *
 * MIT License
 *
 * Copyright (c) 2022 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import HelpersController from './HelpersController';

import WithType from './WithType';

let _this = {};

/**
 *
 */
class HelpersError extends HelpersController {
    /**
     *
     * @param props
     * @param main
     */
    constructor(props, main) {
        super(props);
        this.props = props;
        this.main = main;

        this.state = {
            errors: null
        };

        _this = this;
    };

    /**
     *
     * @param id
     */
    removeElementError = ({target: {id}}) => {
        const
            {document} = this.props,
            helpersElement = AllTap.$helpersElement({document: document}),
            helpersClass = AllTap.$helpersClass({document: document});

        let element = helpersElement.getById(id);

        if (this.isElement(element) && helpersClass.hasClass(element, 'is-invalid')) {
            this.throttle('helpers-error', () => {
                helpersClass.removeClass(element, 'is-invalid');

                let
                    parent = element.parentNode,
                    children = this.elementToArray(parent.getElementsByTagName('small'));

                if (this.isArrayIf(children)) {
                    children.map((child) => {
                        parent.removeChild(child);
                    });
                }
            }, 300);
        }
    };

    /**
     *
     * @param targets
     */
    createElementError = (targets) => {
        const
            {document} = this.props,
            helpersElement = AllTap.$helpersElement({document: document}),
            helpersClass = AllTap.$helpersClass({document: document});

        for (let target of targets) {
            let
                {_id, error} = target,
                element = helpersElement.getById(_id);

            if (!(this.isElement(element) && helpersClass.hasClass(element, 'is-invalid'))) {
                let
                    small = document.createElement('small'),
                    text = document.createTextNode(error);

                helpersClass.addClass(element, 'is-invalid');
                helpersClass.addClass(small, 'invalid-feedback');
                small.appendChild(text);
                element.parentNode.appendChild(small);

                this.removeListener('keyup', `helpers-error-clear-keyup-${this.toSlug(_id)}`, this.removeElementError, () => {
                    this.addListener(element, 'keyup', `helpers-error-clear-keyup-${this.toSlug(_id)}`, this.removeElementError);
                });

                this.removeListener('change', `helpers-error-change-keyup-${this.toSlug(_id)}`, this.removeElementError, () => {
                    this.addListener(element, 'change', `helpers-error-change-keyup-${this.toSlug(_id)}`, this.removeElementError);
                });
            }
        }
    };

    /**
     *
     * @param errors
     */
    setErrors = (errors) => {
        if (this.isObjectIf(errors)) {
            let
                _id = '',
                prefixes = [],
                targets = [];

            const execute = (object, callback) => {
                if (this.isObjectIf(object)) {
                    let keys = this.keysObject(object);

                    this.recursiveSyncMap(keys, 0, keys.length, (item, next) => {
                        this.isObjectIf(object[item]) && prefixes.push(item);

                        _id = this.isEmpty(_id) ? item : `${_id}_${item}`;

                        execute(object[item], () => {
                            _id = _id.match(new RegExp(prefixes.join('_'), 'g'));
                            next(true);
                        });
                    }, () => {
                        _id = '';
                        prefixes = [];
                        callback(true);
                    });
                } else {
                    targets.push({_id: _id, error: this.firstArray(object)});
                    callback(true);
                }
            };

            for (let property in errors) {
                execute({[property]: errors[property]}, () => {
                    this.createElementError(targets);
                    targets = [];
                });
            }
        }
    };
}

/**
 *
 * @type {{}}
 */
HelpersError.propTypes = {};

/**
 *
 * @type {{}}
 */
HelpersError.defaultProps = {};

/**
 *
 * @param ClassObject
 * @param className {className: 'className'}
 * @returns {function(*): function({}=): *} pass _this ClassMain (required) and props {} (optional)
 */
export default WithType(HelpersError, {className: 'HelpersError'});
